import { render, staticRenderFns } from "./topics.vue?vue&type=template&id=b03b0e9c&scoped=true&"
import script from "./topics.vue?vue&type=script&lang=js&"
export * from "./topics.vue?vue&type=script&lang=js&"
import style0 from "./topics.vue?vue&type=style&index=0&id=b03b0e9c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03b0e9c",
  null
  
)

export default component.exports